module.exports = __webpack_public_path__ + "img/mcia-banner.05cc9fe7.png";